// import dayjs from 'dayjs'

import Title from 'components/Title'
// import Span from 'components/Span'
import Image from 'components/Image'
import Paragraph from 'components/Paragraph'
import Link from 'components/Link'
import Icon from 'components/Icon'

import theme from 'style/theme'

import Styled from './styled'

export default function CardVoucher({
  title,
  detail,
  image,
  // validStartDate,
  // validEndDate,
  showReadMore = false,
  link = '',
}) {
  return (
    <Styled>
      <div className="image-block">
        <Image src={image} imgixWidth={900} />
      </div>

      <div className="info-block">
        <div className="title-block">
          <Title level={4}>{title}</Title>
        </div>

        <div className="detail-block">
          <Paragraph ellipsis={{ rows: 2 }}>{detail}</Paragraph>
        </div>

        {/* <div className="date-block">
          <Span small className="text-date">
            ระยะเวลาโปรโมชั่น {validStartDate ? dayjs(validStartDate).format('DD MMM YYYY') : null}{' '}
            - {validEndDate ? dayjs(validEndDate).format('DD MMM YYYY') : 'ไม่มีกำหนด'}
          </Span>
        </div> */}

        {showReadMore && (
          <div className="read-more-block">
            <Link href={link}>
              <Paragraph className="text-read-more">อ่านเพิ่มเติม</Paragraph>
            </Link>
            <Icon.ChevronRight style={{ color: theme.primaryRed }} />
          </div>
        )}
      </div>
    </Styled>
  )
}
